export default {
    campaignSettings: [
        'not_opened',
        'delivered',
        'bounced',
    ],
    checkedSettings: []
}



// WEBPACK FOOTER //
// ./src/app/campaign/vuex/state.js